import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h",
  "use": "icon-h-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h\"><path fill=\"#333333\" d=\"M120.832 35.84h173.056v403.456h436.224V35.84h173.056v952.32H730.112v-399.36H293.888v399.36H120.832v-952.32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol